import React, { useEffect, useState } from 'react'
import { globalGetService } from '../../../../globalServices';
import { checkApiStatus } from '../../../utils_v2';
import ConfigData from '../../master/components/ConfigData';
import { Grid, Paper, Tab, Tabs, TextField, Typography } from '@material-ui/core';
import { Link } from 'react-router';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { PageLoader } from '../../../shared_elements';
import SvEvents from '../../maintenancePrograms/pages/SvEvents';

const ApuTypeView = () => {

    const [tabValue, setTabValue] = useState(0);
    const [apuTypeViewInfo, setApuTypeViewInfo] = useState({});
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
      getApuTypeView();
    },[])

    const FrontendUrl = window.location.pathname;
    const path = FrontendUrl.split('/');
    const id = path[path.length-1];

    const getApuTypeView = (query) => {
      setLoading(true)
      globalGetService(`config-data/apu-type/${id}/`, query)
        .then(response => {
            if(checkApiStatus(response)) {
                setApuTypeViewInfo(response?.data?.data)
            }
            setLoading(false)
        })
    }

    const handleTabChange = (event,newValue) => {
         setTabValue(newValue)
    }


  return (
     <section className="asset-tech-specs" style={{ margin: '25px 0 0 75px' }}>
            <Paper elevation={0} className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - 89}px` }}>
                <ConfigData />
                <div className="tech-specs-content" style={{ padding: "10px 0px" }}>
                    <div style={{ display: "flex", alignItems: 'center', marginLeft: "10px" }}>
                        <Link to="/config-data/apuTypes/" fontSize="small" classname="back-icon" style={{ color: "#3f51b5" }}><ArrowBackIcon style={{ color: "#3f51b5", verticalAlign: 'top' }} /></Link>
                        <Typography variant="h7" >{apuTypeViewInfo?.name}</Typography>
                    </div>
                    <div className='console-management-modal' style={{ padding: "0px 10px" }}>
                        <Grid container spacing={1}>
                            <Grid item md={6} >
                                <TextField
                                    name='manufacturer'
                                    label='Manufacturer'
                                    disabled
                                    value={apuTypeViewInfo?.manufacturer?.name || ''}
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={6} >
                                <TextField
                                    name='aircraft_type'
                                    label='Aircraft Type'
                                    disabled
                                    value={apuTypeViewInfo?.aircraft_type?.map((item) => item.name) || ''}
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={12} >
                                <TextField
                                    name='remarks'
                                    label='Remarks'
                                    disabled
                                    value={apuTypeViewInfo?.remarks || ''}
                                    fullWidth
                                    multiline
                                    rows={3}
                                    margin="normal"
                                    inputProps={{ maxLength: 255 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                        </Grid>
                    </div>
                    <div square style={{ padding: '8px 10px' }}>
                        <Paper elevation={0} className="console-paper">
                            <Tabs
                                value={tabValue}
                                onChange={handleTabChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="fullWidth"
                            >
                                <Tab label="Maintenance Program" />
                            </Tabs>
                        </Paper>
                        {tabValue === 0 && <SvEvents isApu={true} linkedTypeName={apuTypeViewInfo?.name || ''} deleted={apuTypeViewInfo.deleted_at}/>}
                    </div>
                </div>
            </Paper>
            {isLoading ? <PageLoader /> : null}
        </section>
  )
}

export default ApuTypeView 